import React, { useEffect, useState } from "react";
import api from "../../api";

const AdmitListPage = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const student = params.get("student");
    const exam = params.get("exam");

    if (student && exam) {
      loadStudent(student, exam);
    }
  }, []);

  const loadStudent = async (student, exam) => {
    try {
      const res = await api.get(`/student/mark-sheet/view/${student}/${exam}`);
      setData(res.data.data);
    } catch (err) {
      console.log(err);
      alert("Error loading data");
    }
  };

  const printAdmit = () => {
    if (!data) return;

    const win = window.open("", "_blank");

    win.document.write(`
    <html>
    <head>
      <title>Admit Card</title>
      <style>
        body { font-family: Arial; padding: 20px; }
        .card {
          border: 2px solid black;
          padding: 20px;
          width: 500px;
          margin: auto;
        }
        .title {
          text-align: center;
          font-size: 22px;
          font-weight: bold;
        }
        .row {
          margin: 10px 0;
          font-size: 16px;
        }
      </style>
    </head>

    <body>
      <div class="card">
        <div class="title">ADMIT CARD</div>

        <div class="row"><b>Name:</b> ${data.student.name}</div>
        <div class="row"><b>Roll:</b> ${data.student.roll_no}</div>
        <div class="row"><b>Class:</b> ${data.student.class_name}</div>
        <div class="row"><b>Exam:</b> ${data.exam.exam_name}</div>

        <br><br><br>

        <div class="row">Signature: ____________________</div>
      </div>
    </body>
    </html>
    `);

    win.print();
  };

  if (!data) return <h3 style={{ padding: 20 }}>No Data Found</h3>;

  return (
    <div style={{ padding: 20 }}>
      <h2>Admit Card</h2>

      <p><b>Name:</b> {data.student.name}</p>
      <p><b>Roll:</b> {data.student.roll_no}</p>
      <p><b>Class:</b> {data.student.class_name}</p>
      <p><b>Exam:</b> {data.exam.exam_name}</p>

      <br />

      <button onClick={printAdmit}>
        Print Admit
      </button>
    </div>
  );
};

export default AdmitListPage;